import { FormikHelpers } from "formik";
import { useCreateCostBy } from "./api/createCostBy";
import CostByTypeForm from "./CostByForm";


const CreateCostBy = ({handleCloseModal}: CreateCostByProps)  => {
  const createCostByMutation = useCreateCostBy({data: {}});

  const initialValues: IPostNewCostBy = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewCostBy, { setSubmitting }: FormikHelpers<IPostNewCostBy>): Promise<void> => {
    try {
      await createCostByMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CostByTypeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateCostByProps {
  handleCloseModal: () => void;
}

export default CreateCostBy;